export default __webpack_public_path__ + "static/media/ExamPerformanceIcon.b0ce4b95.svg";